import React from "react";

const readSessionValue = (key: string): string | null => {
  try {
    const timestamp = sessionStorage.getItem("tdf_selected_timestamp");
    if (!timestamp) return null;
    const storedTime = parseInt(timestamp, 10);
    const currentTime = Date.now();
    if (currentTime - storedTime > 20 * 60 * 1000) {
      sessionStorage.removeItem("tdf_selected_period");
      sessionStorage.removeItem("tdf_selected_model_id");
      sessionStorage.removeItem("tdf_selected_timestamp");
      return null;
    }
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
};

export const useInitContextFromUrlAndSession = (args: {
  tenantSymbol: string;
  ctx: any;
  params: { model?: string };
  location: { search: string };
}) => {
  const { tenantSymbol, ctx, params, location } = args;

  React.useEffect(() => {
    if (tenantSymbol && tenantSymbol !== ctx.tenant) {
      ctx.sendValue("tenant", tenantSymbol);
    }

    const storedModelId = readSessionValue("tdf_selected_model_id");
    const storedPeriod = readSessionValue("tdf_selected_period");

    const urlModel = params.model;
    const targetModelId = urlModel || storedModelId || ctx.modelId;
    if (targetModelId && targetModelId !== ctx.modelId) {
      ctx.sendValue("modelId", targetModelId);
    }

    const urlPeriodParam = new URLSearchParams(location.search).get("period");
    const urlPeriod = urlPeriodParam ? decodeURIComponent(urlPeriodParam) : null;
    const targetPeriod = urlPeriod || storedPeriod || ctx.period;
    if (targetPeriod && targetPeriod !== ctx.period) {
      ctx.sendValue("period", targetPeriod);
    }
  }, [ctx, location.search, params.model, tenantSymbol]);
};

